import { GzContentPrefilteringWebComponent } from './component/GzContentPrefilteringWebComponent';

export { GzContentPrefilteringWebComponent };
